import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.css']
})
export class HelpDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<HelpDialogComponent>,
  ) { 
    dialogRef.disableClose = true;
   }

  hide() {
    this.dialogRef.close()
  }
}
